import React, { useState } from "react";
import { STATIC_URL } from "../contexts/UserContext";
import { ImageOff } from "lucide-react";

/**
 * Diagram component — shows AI-generated diagram image, or a graceful SVG fallback.
 */
const Diagram = ({ diagramKey, caption }) => {
 const [failed, setFailed] = useState(false);
 // Append a version tag to bust browser/CDN caches when diagrams are regenerated
 const src = `${STATIC_URL}/images/${diagramKey}.png?v=3`;

 return (
 <figure
 data-testid={`diagram-${diagramKey}`}
 className="my-8 rounded-sm overflow-hidden border border-zinc-200 bg-white "
 >
 {!failed ? (
 <img
 src={src}
 alt={caption || diagramKey}
 onError={() => setFailed(true)}
 className="w-full h-auto object-contain bg-zinc-50 max-h-[480px]"
 loading="lazy"
 />
 ) : (
 <div className="w-full aspect-[16/9] flex flex-col items-center justify-center bg-gradient-to-br from-orange-50 to-zinc-50 text-center p-8 gap-3">
 <div className="w-14 h-14 rounded-full bg-orange-500/10 flex items-center justify-center">
 <ImageOff className="w-7 h-7 text-orange-500" />
 </div>
 <div className="text-sm uppercase tracking-[0.2em] font-semibold text-orange-600 ">
 Diagram
 </div>
 <div className="text-base text-zinc-600 max-w-md">
 {caption || "Visual diagram for this topic."}
 </div>
 </div>
 )}
 {caption && !failed && (
 <figcaption className="px-4 py-2 text-xs uppercase tracking-[0.2em] text-zinc-500 border-t border-zinc-200 ">
 {caption}
 </figcaption>
 )}
 </figure>
 );
};

export default Diagram;
